import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import TextTranslate from '../TextTranslate/TextTranslate';

const ConfirmedButton = ({confirmTitle, confirmText, children, onClick, ...rest}) => {
    
    if(!confirmTitle) {
        confirmTitle = <TextTranslate name="modal-please-confirm" fallback="Please Confirm" textOnly/>;
    }

    if (!confirmText) {
        confirmText = <TextTranslate name="modal-question" fallback="Are you sure?" textOnly/>
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleYes = () => {
        setShow(false);
        onClick();
    };

    return (
        <>
            <button {...rest} onClick={handleShow}>
                {children}
            </button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{confirmTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{confirmText}</Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        <TextTranslate name="word-no" fallback="No" textOnly/>
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleYes}>
                        <TextTranslate name="word-yes" fallback="Yes" textOnly/>
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default ConfirmedButton;
